import { BP42SubmitResult } from '@r1-frontend/bp42/actions/thunk/submit';
import { BP42Action } from '@r1-frontend/bp42/constants/actions';

import { IAction } from '@r1-frontend/shared/types/Redux';

const setSubmitResult = (result: BP42SubmitResult): IAction<BP42Action.SetSubmitResult, BP42SubmitResult> => ({
    type: BP42Action.SetSubmitResult,
    payload: {
        ...result,
    },
});

export default setSubmitResult;
